<template>
  <div class="page-contents ql-editor ql-container" v-html="html" />
</template>

<script>
export default {
  data() {
    return {
      html: ''
    }
  },
  mounted() {
    this.loadPage()
  },
  methods: {
    loadPage() {
      this.$axios
        .$get(
          '/page/public/page?menu=' +
            encodeURIComponent(this.$router.currentRoute.fullPath),
          { no_loading: true }
        )
        .then(response => {
          if (response.resultCode === 'success') {
            this.html = response.data
          }
          this.$eventHub.$emit('content-loaded')
        })
        .catch(() => {
          this.$eventHub.$emit('content-loaded')
        })
    }
  }
}
</script>
